(function() {
    'use strict';

    angular.module('stats')
        .controller('SalesStatsController', SalesStatsController);

        SalesStatsController.$inject = ['$state', '$scope', 'salesStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function SalesStatsController($state, $scope, salesStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;
        var initialStat = {
            noWeeks: null,
            noMonths: null,
            noYears: null,
            isDefault: false
        }
        var firstStat = Object.assign({}, initialStat);
        firstStat.isDefault = true
        self.stats = [firstStat,]
        self.noComparative = 0;

        self.addComparativeWeeks = addComparativeWeeks;
        self.addComparativeMonths = addComparativeMonths;
        self.addComparativeYears = addComparativeYears;

        self.chartOptions = {
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        var datasetIndex = tooltipItem.datasetIndex;
                        var seriesLabel = data.datasets[datasetIndex].label;
                        return seriesLabel + ': ' + tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    }
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        callback: function (value) {
                            return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        }
                    }
                }],
                xAxes: [],
            }
        };
        self.salesChartsInfo = {
            'net_sum_without_delivery_costs': {
                label: 'Wartość zamówień netto bez kosztów przesyłki i podziału zamówienia',
                is_showed: false,
                chartData: [],
            },
            'num_of_orders': {
                label: 'Ilość zamówień',
                is_showed: false,
                chartData: [],
            }, 
            'num_of_on_cash_delivery_orders': {
                label: 'Ilość zamówień pobraniowych',
                is_showed: false,
                chartData: [],
            }, 
            'num_of_order_products': {
                label: 'Ilość zamówionych produktów',
                is_showed: false,
                chartData: [],
            }, 
            'num_of_orders_sent_on_day_set_by_system': {
                label: 'Ilość zamówień wysłanych w dniu wyznaczonym przez system',
                is_showed: false,
                chartData: [],
            }, 
            'num_of_delayed_orders': {
                label: 'Ilość zamówień opóźnionych',
                is_showed: false,
                chartData: [],
            }, 
            'num_of_delayed_days_max': {
                label: 'Max ilość dni opóźnienia',
                is_showed: false,
                chartData: [],
            },
            'num_of_delayed_days_min': {
                label: 'Min ilość dni opóźnienia',
                is_showed: false,
                chartData: [],
            }          
        }

        self.chartLabels = [];
        self.chartSeries = [];

        $scope.$on('reset-charts-data', function(event, data) {
            self.chartLabels = [];
            self.chartSeries = [];
            self.noComparative = 0;
            self.chartOptions.scales.xAxes = [];

            for(var prop in self.salesChartsInfo) {
                self.salesChartsInfo[prop].chartData = [];
            }

            while(self.stats.length > 1) {
                self.stats.pop();
            }
        });

        $scope.$on('charts-data', function(event, data) {
            var datasetLabel = 'Tabela ' + (self.chartSeries.length + 1);
            self.chartSeries.push(datasetLabel);
            var datasetIndex = self.chartSeries.length - 1;

            for(var prop in data.salesChartsInfo) {
                self.salesChartsInfo[prop].chartData.push(data.salesChartsInfo[prop].chartData);
            }

            if(self.chartLabels.length == 0) {
                self.chartLabels = data.chartLabels;
            } else {
                self.chartLabels = concatLabels(self.chartLabels, data.chartLabels);
            }     
            self.chartOptions.scales.xAxes.push({
                id:'xAxis' + self.chartSeries.length,
                type:"category",
                scaleLabel: {
                    display: true,
                    labelString: datasetLabel
                
                },
                gridLines: {
                    drawOnChartArea: false,
                },
                ticks:{
                    callback: function(label){
                        var date = String(label).split("#")[datasetIndex];
                        return date;
                    }
                }
            });    
        });
        
        function concatLabels(currentLabels, newLabels) {
            var labels = [];
            for(var i = 0; i < currentLabels.length; i++) {
                var newLabel = currentLabels[i] + '#' + newLabels[i];
                labels.push(newLabel);
            }
            return labels;
        }

        function addComparativeWeeks() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noWeeks = self.noComparative;
                self.stats.push(stat);
            }
        }
        function addComparativeMonths() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noMonths = self.noComparative;
                self.stats.push(stat);
            }
        }
        function addComparativeYears() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noYears = self.noComparative;
                self.stats.push(stat);
            }
        }
    }
})();
